export default __webpack_public_path__ + "static/media/puhelinhalyttaa.5467f80a.mp3";